import http from "./httpService";

const apiEndPoint = "/operatingmodes/";

function getOperatingModes() {
  return http.get(apiEndPoint);
}

export default getOperatingModes;
